var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructorVectorLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 64,
    viewBox: "0 0 32 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6691 31.9954C12.6691 42.5049 21.0544 51.0547 31.5 51.3199V63.4961C14.334 63.229 0.5 49.2296 0.5 32C0.5 14.7704 14.334 0.771035 31.5 0.503888V12.6709C21.0544 12.936 12.6691 21.4858 12.6691 31.9954Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructorVectorLeft);
export default __webpack_public_path__ + "static/media/instructor-vector-left.79dbdfcc9aed0f76f5bfe54dd0bed1a7.svg";
export { ForwardRef as ReactComponent };